import ItemSubstitutionButton from 'components/ItemSubstitution/ItemSubstitutionButton/ItemSubstitutionButton';

export default ItemSubstitutionButton;
